import { AJOUTER_FORMULAIRE_DONNEES_PERSONNELLES } from './actionTypes'

export const ajouterFormulaireDonneesPersonnelles = (formulaireDonneesPersonnelles) => {
	return ({
		type: AJOUTER_FORMULAIRE_DONNEES_PERSONNELLES,
		payload: formulaireDonneesPersonnelles
	})
}
